import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { StyledDebtModal } from '../reports/debt_list/debtList.styled';
import Checkbox from '../../common/simple/Checkbox';


const WarningLetterModal = ({ show, onHide, checkboxes, setCheckboxes, onSend }) => {
    const { t } = useTranslation();
    const { owner, renter } = checkboxes;

    const [sendLetterBtnDisabled, setSendLetterBtnDisabled] = useState(false);

    useEffect(() => {
        if (owner || renter) setSendLetterBtnDisabled(false);
        else setSendLetterBtnDisabled(true);
    }, [checkboxes]);

    return (
        <StyledDebtModal
            centered
            show={show}
            onHide={onHide}
            size="lg"
        >
            <Modal.Header>
                <Modal.Title>{t('notifications.warningLetterTitle')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                    <h5>{t('notifications.sendWarningLetterTo')}:</h5>

                    <Checkbox
                        label={t('reports.paymentRequestPopUp.labels.owner')}
                        checked={checkboxes.owner}
                        onChange={e => setCheckboxes({...checkboxes, owner: e})}
                    />

                    <Checkbox
                        label={t('reports.paymentRequestPopUp.labels.renter')}
                        checked={checkboxes.renter}
                        onChange={e => setCheckboxes({...checkboxes, renter: e})}
                    />

                    <button
                        className={'bllink-button'}
                        onClick={onSend}
                        disabled={sendLetterBtnDisabled}
                    >
                        {t('reports.paymentRequestPopUp.btns.send')}
                    </button>
            </Modal.Body>
        </StyledDebtModal>
    )
}

export default WarningLetterModal;